module.exports = '<svg width="48" height="32" viewBox="0 0 48 32"><path d="M23.728 0C14.469 0 5.581 5.624.533 14.683l-.384.688c-.211.379-.2.987.024 1.36l.405.672C5.943 26.27 15.029 32 23.727 32c8.661 0 17.296-5.355 23.104-14.323l.467-.723c.261-.397.267-1.048.016-1.451l-.456-.728C40.991 5.386 32.562-.001 23.727-.001zm0 24c-4.331 0-7.845-3.584-7.845-8s3.515-8 7.845-8c4.333 0 7.845 3.584 7.845 8s-3.512 8-7.845 8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eye-2.js
// module id = 1135
// module chunks = 14